import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LTIDeeplinkingService } from '../../lti/core/ltideeplinking.service';
import { TranslateService } from '@ngx-translate/core';
import { DeeplinkConfig } from '../../lti/shared/deeplink-config';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { CitationListsConfigurationService, ListService } from '../../ajs-upgraded-providers';


@Component({
  selector: 'rl-selection-toolbar',
  templateUrl: './selection-toolbar.component.html',
  styleUrls: ['./selection-toolbar.component.scss', './selection-toolbar.component-rtl.css']
})
export class SelectionToolbarComponent implements OnInit {
  
  @Input() list:any;
  @Input() type:string;
  @Output() invalidSelection=new EventEmitter<string>();

  //this is used, so we can pickup the value from the input text. The translation didnt arrive on time
  @ViewChild('linkLabel') linkLabel:ElementRef;

  config:  DeeplinkConfig = new DeeplinkConfig();
  displayStyles: any[];
  errorExists : boolean;

  constructor(private listService : ListService, private deeplinkSerivce: LTIDeeplinkingService, private citationStylesService : CitationListsConfigurationService) {}

  ngOnInit(): void {
    this.citationStylesService.getBibStyles().then((styles) => {
      this.displayStyles = styles;
      //set default style
      styles.map((x) => {if (x.value=="exlibris") {this.config.displayStyle = x;}});
    });
	
    this.config.selectType=this.type;
    this.config.embedMode="brief";
    
  }

  selectLink() {
    if (this.list.selectedCitations.length > 0) {

      var links : Array<any>;
      var linkDetails : any;
      var type: EntityType;

      links = new Array<any>();
      
      for (var i = 0; i < this.list.selectedCitations.length; i++) {
        //Link to list
        if (this.list.selectedCitations[i] == this.list.id) {
          type = EntityType.LIST;
          linkDetails = {"id": this.list.id, "title" : this.list.name};
          links.push({"type": type, "linkData" : linkDetails});
        } else {
          var items = this.listService.getCitationsFromListByIds(this.list, [this.list.selectedCitations[i]]);
          
          //Link to citation
          if (items.length > 0) {
            type = EntityType.CITATION;
            let title = items[0].secondaryType == 'BK_C' ? items[0].dc.rlterms_chapter_title : items[0].dc.title;
            linkDetails = {"id": items[0].id, "title" : title};
          } 
          //link to section
          else {
            items = this.listService.getSectionsFromListByIds(this.list, [this.list.selectedCitations[i]]);
            if (items.length > 0) {
              type = EntityType.SECTION;
              linkDetails = {"id": items[0].id, "title" : items[0].name};
            }
          }

          links.push({"type": type, "linkData" : linkDetails});
        }
      }

      if (links.length > 0) {
        this.deeplinkSerivce.links(links);
      } 
    } else {
       this.errorExists = true;
    }  
  };

  addItems () {
    //taking the value manually as we couldnt traslate it here
    this.config.linkLabel = this.linkLabel.nativeElement.value;

		if (this.list.selectedCitations.length > 0) {
      this.deeplinkSerivce.embedItems(this.config, this.list.selectedCitations, this.list);
    } else {
      this.errorExists = true;
    }
	};


}
